/* eslint-disable no-loss-of-precision */
import gql from 'graphql-tag'
import * as d3 from 'd3'
import {
  clusterCountLayerHousehold,
  clusterLayerChildcare,
  clusterLayerGrocery,
  clusterLayerHospitals,
  clusterLayerHousehold,
  clusterLayerMentalHealthCareFacilities,
  clusterLayerFqhc,
  clusterLayerObgyn,
  clusterLayerPharmacy,
  clusterLayerUrgentCare,
  unclusteredLayerHousehold,
  unclusteredLayerOutreachPartial,
  clusterCountLayerHospitals,
  clusterCountLayerUrgentCare,
  clusterCountLayerGrocery,
  clusterCountLayerPharmacies,
  clusterCountLayerChildcare,
  clusterCountLayerObgyn,
  clusterCountLayerMentalHealthCareFacilities,
  clusterCountLayerFqhc
} from './Layers/config'
import theme from '../../../../themes/pTheme/pTheme'
import {Layer} from './MaptilerWrapper'
import {getOutreachSimulationTooltipFieldData, getPOIImageUrl, getPersonaCustomName, visualOptions} from '../../helper'
import {countyFipsMap} from './Counties'

export const poiNameMap = {
  hospitals: ['Hospital', theme.palette.hpRedDark],
  urgentCare: ['Urgent Care Facility', theme.palette.hpOrangeDark],
  pharmacies: ['Pharmacy', theme.palette.hpBaseDarker],
  groceryStores: ['Grocery Store', theme.palette.hpYellowDarker],
  childCare: ['Child Care Facility', theme.palette.hpYellowDark],
  obgynPhysicianFacilities: ['OBGYN', theme.palette.hpGreenVividDark],
  mentalHealthCareFacilities: ['Mental Health Facility', theme.palette.hpPupleDark],
  fqhc: ['Federally Qualified Health Center and Service Site', theme.palette.hpBrownLighter]
}

export function conv4326To900913(coord) {
  const transCoord = [0, 0]
  transCoord[0] = coord[0] * 111319.49077777778
  transCoord[1] = Math.log(Math.tan((90 + coord[1]) * 0.00872664625997)) * 6378136.999112157
  return transCoord
}

export function debounce(func, wait, immediate) {
  let timeout
  return function (...args) {
    const later = () => {
      timeout = null
      if (!immediate) func.apply(this, args)
    }
    const callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(this, args)
  }
}

export function loadImageToMap(map, imgName, img) {
  if (map && !map.hasImage(imgName)) {
    map.addImage(imgName, img) // Add the image to the map
  }
}
export function loadImages(map, poiConfig) {
  const img1 = new Image(128, 128)
  img1.onload = () => {
    loadImageToMap(map, `hospitals-svg`, img1)
  }
  img1.src = getPOIImageUrl(poiConfig?.hospitals?.markerProps?.iconURL)

  const img2 = new Image(128, 128)
  img2.onload = () => {
    loadImageToMap(map, `pharmacies-svg`, img2)
  }
  img2.src = getPOIImageUrl(poiConfig?.pharmacies?.markerProps?.iconURL)

  const img4 = new Image(128, 128)
  img4.onload = () => {
    loadImageToMap(map, `urgentCare-svg`, img4)
  }
  img4.src = getPOIImageUrl(poiConfig?.urgentCare?.markerProps?.iconURL)

  const img5 = new Image(128, 128)
  img5.onload = () => {
    loadImageToMap(map, `groceryStores-svg`, img5)
  }
  img5.src = getPOIImageUrl(poiConfig?.groceryStores?.markerProps?.iconURL)

  const img6 = new Image(128, 128)
  img6.onload = () => {
    loadImageToMap(map, `childcare-svg`, img6)
  }
  img6.src = getPOIImageUrl(poiConfig?.childCare?.markerProps?.iconURL)

  const img7 = new Image(128, 128)
  img7.onload = () => {
    loadImageToMap(map, `obgynPhysicianFacilities-svg`, img7)
  }
  img7.src = getPOIImageUrl(poiConfig?.obgynPhysicianFacilities?.markerProps?.iconURL)

  const img8 = new Image(128, 128)
  img8.onload = () => {
    loadImageToMap(map, `mentalHealthCareFacilities-svg`, img8)
  }
  img8.src = getPOIImageUrl(poiConfig?.mentalHealthCareFacilities?.markerProps?.iconURL)

  const img9 = new Image(128, 128)
  img9.onload = () => {
    loadImageToMap(map, `fqhc-svg`, img9)
  }
  img9.src = getPOIImageUrl(poiConfig?.fqhc?.markerProps?.iconURL)
}

export const statesToAbbreviation = {
  Alabama: 'AL',
  Alaska: 'AK',
  'American Samoa': 'AS',
  Arizona: 'AZ',
  Arkansas: 'AR',
  California: 'CA',
  Colorado: 'CO',
  Connecticut: 'CT',
  Delaware: 'DE',
  'District Of Columbia': 'DC',
  'Federated States Of Micronesia': 'FM',
  Florida: 'FL',
  Georgia: 'GA',
  Guam: 'GU',
  Hawaii: 'HI',
  Idaho: 'ID',
  Illinois: 'IL',
  Indiana: 'IN',
  Iowa: 'IA',
  Kansas: 'KS',
  Kentucky: 'KY',
  Louisiana: 'LA',
  Maine: 'ME',
  'Marshall Islands': 'MH',
  Maryland: 'MD',
  Massachusetts: 'MA',
  Michigan: 'MI',
  Minnesota: 'MN',
  Mississippi: 'MS',
  Missouri: 'MO',
  Montana: 'MT',
  Nebraska: 'NE',
  Nevada: 'NV',
  'New Hampshire': 'NH',
  'New Jersey': 'NJ',
  'New Mexico': 'NM',
  'New York': 'NY',
  'North Carolina': 'NC',
  'North Dakota': 'ND',
  'Northern Mariana Islands': 'MP',
  Ohio: 'OH',
  Oklahoma: 'OK',
  Oregon: 'OR',
  Palau: 'PW',
  Pennsylvania: 'PA',
  'Puerto Rico': 'PR',
  'Rhode Island': 'RI',
  'South Carolina': 'SC',
  'South Dakota': 'SD',
  Tennessee: 'TN',
  Texas: 'TX',
  Utah: 'UT',
  Vermont: 'VT',
  'Virgin Islands': 'VI',
  Virginia: 'VA',
  Washington: 'WA',
  'West Virginia': 'WV',
  Wisconsin: 'WI',
  Wyoming: 'WY'
}

export const statesToFIPS = [
  {name: 'Alabama', code: '01'},
  {name: 'Alaska', code: '02'},
  {name: 'Arizona', code: '04'},
  {name: 'Arkansas', code: '05'},
  {name: 'California', code: '06'},
  {name: 'Colorado', code: '08'},
  {name: 'Connecticut', code: '09'},
  {name: 'Delaware', code: '10'},
  {name: 'District Of Columbia', code: '11'},
  {name: 'Florida', code: '12'},
  {name: 'Georgia', code: '13'},
  {name: 'Hawaii', code: '15'},
  {name: 'Idaho', code: '16'},
  {name: 'Illinois', code: '17'},
  {name: 'Indiana', code: '18'},
  {name: 'Iowa', code: '19'},
  {name: 'Kansas', code: '20'},
  {name: 'Kentucky', code: '21'},
  {name: 'Louisiana', code: '22'},
  {name: 'Maine', code: '23'},
  {name: 'Maryland', code: '24'},
  {name: 'Massachusetts', code: '25'},
  {name: 'Michigan', code: '26'},
  {name: 'Minnesota', code: '27'},
  {name: 'Mississippi', code: '28'},
  {name: 'Missouri', code: '29'},
  {name: 'Montana', code: '30'},
  {name: 'Nebraska', code: '31'},
  {name: 'Nevada', code: '32'},
  {name: 'New Hampshire', code: '33'},
  {name: 'New Jersey', code: '34'},
  {name: 'New Mexico', code: '35'},
  {name: 'New York', code: '36'},
  {name: 'North Carolina', code: '37'},
  {name: 'North Dakota', code: '38'},
  {name: 'Ohio', code: '39'},
  {name: 'Oklahoma', code: '40'},
  {name: 'Oregon', code: '41'},
  {name: 'Pennsylvania', code: '42'},
  {name: 'Rhode Island', code: '44'},
  {name: 'South Carolina', code: '45'},
  {name: 'South Dakota', code: '46'},
  {name: 'Tennessee', code: '47'},
  {name: 'Texas', code: '48'},
  {name: 'Utah', code: '49'},
  {name: 'Vermont', code: '50'},
  {name: 'Virginia', code: '51'},
  {name: 'Washington', code: '53'},
  {name: 'West Virginia', code: '54'},
  {name: 'Wisconsin', code: '55'},
  {name: 'Wyoming', code: '56'}
]

export const stateFIPSBounds = {
  '04': [
    [-114.8128344705447, 31.332406253852533],
    [-109.04483902389023, 37.0039183311733]
  ],
  22: [
    [-94.04159013340133, 28.929616299252984],
    [-88.81557807968079, 33.01965045673603]
  ],
  16: [
    [-117.24278650376503, 41.988182656016555],
    [-111.04407577795777, 49.00068691035909]
  ],
  27: [
    [-97.23965108111081, 43.49926865177651],
    [-89.4903653503535, 49.384686592055914]
  ],
  38: [
    [-104.04854178571784, 45.935561934309334],
    [-96.55768522245222, 49.001482836578795]
  ],
  46: [
    [-104.05930966769667, 42.484719157181566],
    [-96.43564922669226, 45.94560106669375]
  ],
  36: [
    [-79.7633786294863, 40.502009391283906],
    [-71.85616396303963, 45.01550900568005]
  ],
  '02': [
    [-172.45989954839547, 51.229087747767466],
    [-129.98119088470884, 71.352561]
  ],
  13: [
    [-85.60674924999249, 30.35909162440624],
    [-80.84375612136121, 35.000591132701324]
  ],
  18: [
    [-88.09054069310693, 37.77191769456694],
    [-84.79556880758807, 41.760531838008376]
  ],
  26: [
    [-90.416403200532, 41.696102361213605],
    [-82.4158668902689, 48.190593622126215]
  ],
  28: [
    [-91.64394174611746, 30.180407208762084],
    [-88.09771928109281, 34.99578761863131]
  ],
  39: [
    [-84.82069386553866, 38.403326567155666],
    [-80.51713036800368, 41.97787393972939]
  ],
  48: [
    [-106.64719063660635, 25.840437651866516],
    [-93.5175532104321, 36.50124523999715]
  ],
  72: [
    [-67.94024421674217, 17.913893886728864],
    [-65.22314866408664, 18.514376610456104]
  ],
  31: [
    [-104.05213107971079, 40.00031853197531],
    [-95.30861091290913, 43.00133792776526]
  ],
  '08': [
    [-109.05919619986199, 36.99275055519555],
    [-102.04212644366443, 41.00306920180849]
  ],
  24: [
    [-79.48700299202991, 37.91709878227782],
    [-75.05063561675617, 39.72303789309089]
  ],
  20: [
    [-102.05289432564325, 36.99275055519555],
    [-94.60151999629996, 40.00301364226419]
  ],
  17: [
    [-91.51472716237161, 36.97041500324003],
    [-87.4947178902789, 42.508772828518275]
  ],
  55: [
    [-92.88583746767468, 42.49159163470634],
    [-86.82351991359913, 47.07725226311263]
  ],
  '06': [
    [-124.41060660766607, 32.5342307609976],
    [-114.13445790587905, 42.00965914828148]
  ],
  19: [
    [-96.63306039630396, 40.37830479583795],
    [-90.14002756307562, 43.50116915708986]
  ],
  42: [
    [-80.52071966199662, 39.720265072840725],
    [-74.69529551145511, 42.269954234532335]
  ],
  30: [
    [-116.05114089810897, 44.35832834237342],
    [-104.04136319773197, 49.000831986071596]
  ],
  29: [
    [-95.76804054400543, 35.99538225441254],
    [-89.09913230512305, 40.613687151061505]
  ],
  12: [
    [-87.63470035600356, 24.51490854927549],
    [-80.03257567895679, 31.000809213282125]
  ],
  21: [
    [-89.57291911219112, 36.49707311372113],
    [-81.96720514115141, 39.14641319952199]
  ],
  23: [
    [-71.08446575455754, 43.059430090190894],
    [-66.9819027206272, 47.459533825428245]
  ],
  49: [
    [-114.05190414404143, 36.99790491333913],
    [-109.04124972989729, 42.0019276110661]
  ],
  40: [
    [-103.00405723377233, 33.61664597114971],
    [-94.43282317863178, 37.002200211792115]
  ],
  47: [
    [-90.3087243807438, 34.98340993888938],
    [-81.64775797577975, 36.67833470843708]
  ],
  41: [
    [-124.55417836738366, 41.99161889477894],
    [-116.46390970729706, 46.26801803457034]
  ],
  54: [
    [-82.63840311783117, 37.2015020600106],
    [-77.72107034750347, 40.63859988208881]
  ],
  '05': [
    [-94.61946646626465, 33.00413641175411],
    [-89.64470499204991, 36.499677711619505]
  ],
  53: [
    [-124.73364306703067, 45.54812601385013],
    [-116.9161607504075, 49.00287618131515]
  ],
  37: [
    [-84.32178200052, 33.85116926668266],
    [-75.45981513195132, 36.5881334409244]
  ],
  51: [
    [-83.67570908179081, 36.540885157941574],
    [-75.24086819838197, 39.46598340442404]
  ],
  56: [
    [-111.05843295392954, 40.995109653686534],
    [-104.05213107971079, 45.006059349083486]
  ],
  '01': [
    [-88.4745951503515, 30.222501133601334],
    [-84.89247974539745, 35.008322669916694]
  ],
  45: [
    [-83.35267262242623, 32.03425802107021],
    [-78.53942937789378, 35.21535605535055]
  ],
  35: [
    [-109.04842831788318, 31.332406253852533],
    [-103.0004679397794, 37.00051245413642]
  ],
  33: [
    [-72.55607629166292, 42.696906900759004],
    [-70.70400059130591, 45.30587118110181]
  ],
  60: [
    [-170.84530299432993, -14.373864584355843],
    [-169.42394257312571, -14.157381542325423]
  ],
  50: [
    [-73.43904261392613, 42.726973989929895],
    [-71.49364526975269, 45.01550900568005]
  ],
  32: [
    [-120.00654287832877, 35.00145019239192],
    [-114.04113626206261, 42.0019276110661]
  ],
  15: [
    [-160.24970712717126, 18.91727560534605],
    [-154.80833743387433, 22.23238695135951]
  ],
  25: [
    [-73.507239199792, 41.23908260581605],
    [-69.92871308883089, 42.88675909238091]
  ],
  78: [
    [-65.08675549235492, 17.679370591195905],
    [-64.57707574535745, 18.38465859717597]
  ],
  44: [
    [-71.85975325703257, 41.15145851737517],
    [-71.12035869448694, 42.019108804878044]
  ],
  34: [
    [-75.56031536375363, 38.928212038110374],
    [-73.8948829510295, 41.357632843118424]
  ],
  10: [
    [-75.7900301793018, 38.45143390982909],
    [-75.05063561675617, 39.8370971907619]
  ],
  '09': [
    [-73.72618613336134, 40.98480093739937],
    [-71.78796737717377, 42.050894013430124]
  ],
  69: [
    [145.12024720417202, 14.110836636456362],
    [146.0821779942799, 18.81247032309323]
  ],
  66: [
    [144.62133533915335, 13.245763528025279],
    [144.9587289744897, 13.652098761677614]
  ],
  11: [
    [-77.11806895668957, 38.79162154730547],
    [-76.90988990509905, 38.99435963428633]
  ]
}

export const getPOIQuery = (selectedPOIs = [], poiConfig = {}) => {
  const selectedPOIsQuery = selectedPOIs.map((poi) => {
    const tooltipAttributes = poiConfig[poi]?.tooltipAttributes || {}
    return `${poi} {
    latitude
    longitude
    name
    address
    city
    state
    zip
    ${Object.keys(tooltipAttributes).join(' ')}
   }
    `
  })

  const defaultPOIQuery = `providersAllocatedHospitals {
    latitude
    longitude
    name
    address
    city
    state
    zip
  }`

  const fields = `{ ${selectedPOIs.length ? selectedPOIsQuery : defaultPOIQuery} }`
  const query = `
      query placesOfInterest($filters: PlacesOfInterestFilter) {
          placesOfInterest(filters: $filters) ${fields}
    }`
  return gql`
    ${query}
  `
}

export const loadOutreachSimulationImage = (mapInstance, imgName) => {
  const img = new Image(128, 128)
  img.onload = () => {
    if (mapInstance && !mapInstance.hasImage(imgName)) {
      mapInstance.addImage(imgName, img)
    }
  }
  img.src = require('../../../../icons/map/partial-enrolled.svg')
}

/**
 * Convert benefits array to GraphQL query field string
 * Used for dynamic query building in UniqueHouseholdsQuery
 * @param {Array} benefitsData - Array of benefit objects like [{snapEnrolled: [0,1]}, {medicareEnrolled: [0]}]
 * @returns {string} Space-separated string of enrolled keys for GraphQL query
 */
export const getBenefitsQueryFields = (benefitsData) => {
  if (!benefitsData || benefitsData.length === 0) {
    return ''
  }
  // Extract keys from each benefit object
  const keys = benefitsData.map((benefit) => Object.keys(benefit)[0]).filter(Boolean)
  return keys.join(' ')
}

const heatMapStyles = [
  [
    'interpolate',
    ['linear'],
    ['heatmap-density'],
    0,
    theme.palette.heatmapColor.default,
    0.3,
    theme.palette.heatmapColor.purpleDark,
    0.6,
    theme.palette.heatmapColor.purpleMedium,
    1,
    theme.palette.heatmapColor.purpleLight
  ],
  [
    'interpolate',
    ['linear'],
    ['heatmap-density'],
    0,
    theme.palette.heatmapColor.default,
    0.3,
    theme.palette.heatmapColor.greenDark,
    0.6,
    theme.palette.heatmapColor.greenMedium,
    1,
    theme.palette.heatmapColor.greenLight
  ]
]

/**
 * Get grouped data using filter management system
 * @param {Object} data - GeoJSON data with features
 * @param {Array} selectedOptionsWithConfig - Array of selected options with enrolledKey (from useOutreachFilters)
 * @param {string} selectedFocusLayer - Current focus layer value
 * @returns {Array|Object} Grouped data for visualization
 */
export const getGroupedData = (data, selectedOptionsWithConfig, selectedFocusLayer) => {
  if (!data) {
    return data
  }

  // Extract enrolledKeys from selected options
  const selectedKeys = selectedOptionsWithConfig?.map((opt) => opt.enrolledKey).filter(Boolean) || []

  if (selectedKeys.length === 0) {
    return data
  }

  const groupedData = filterDataBySelectedKeys(data, selectedKeys, selectedFocusLayer)
  return groupedData
}

const filterDataBySelectedKeys = (data, selectedKeys, selectedFocusLayer) => {
  const circleGreen = {'circle-color': theme.palette.heatmapColor.greenMedium}
  const circlePurple = {'circle-color': theme.palette.heatmapColor.purpleDark}
  const textWhite = {'text-color': theme.palette.hpWhite}
  const fullEnrolled =
    data?.features?.filter((feature) => {
      return selectedKeys.every((key) => feature.properties[key] === 1)
    }) || []
  const notEnrolled =
    data?.features?.filter((feature) => {
      return selectedKeys.every((key) => feature.properties[key] === 0)
    }) || []
  const partialEnrolled =
    data?.features?.filter((feature) => {
      return (
        selectedKeys.some((key) => feature.properties[key] === 1) &&
        selectedKeys.some((key) => feature.properties[key] === 0)
      )
    }) || []
  if (selectedFocusLayer === visualOptions[1].value) {
    return [
      {
        key: 'fullEnrolled',
        data: {...data, features: fullEnrolled},
        layers: [
          {
            ...unclusteredLayerHousehold,
            paint: {
              ...unclusteredLayerHousehold.paint,
              ...circleGreen
            },
            id: 'unclustered-fullEnrolled',
            source: unclusteredLayerHousehold.source + 'fullEnrolled'
          },
          {
            ...clusterLayerHousehold,
            paint: {
              ...clusterLayerHousehold.paint,
              ...circleGreen
            },
            id: 'clustered-fullEnrolled',
            source: unclusteredLayerHousehold.source + 'fullEnrolled'
          },
          {
            ...clusterCountLayerHousehold,
            id: 'clusterCount-fullEnrolled',
            source: unclusteredLayerHousehold.source + 'fullEnrolled',
            paint: textWhite
          }
        ]
      },
      {
        key: 'notEnrolled',
        data: {...data, features: notEnrolled},
        layers: [
          {
            ...unclusteredLayerHousehold,
            paint: {
              ...unclusteredLayerHousehold.paint,
              ...circlePurple
            },
            id: 'unclustered-notEnrolled',
            source: unclusteredLayerHousehold.source + 'notEnrolled'
          },
          {
            ...clusterLayerHousehold,
            paint: {
              ...clusterLayerHousehold.paint,
              ...circlePurple
            },
            id: 'clustered-notEnrolled',
            source: unclusteredLayerHousehold.source + 'notEnrolled'
          },
          {
            ...clusterCountLayerHousehold,
            id: 'clusterCount-notEnrolled',
            source: clusterCountLayerHousehold.source + 'notEnrolled',
            paint: textWhite
          }
        ]
      },
      {
        key: 'partialEnrolled',
        data: {...data, features: partialEnrolled},
        layers: [
          {...unclusteredLayerOutreachPartial, id: 'unclustered-partialEnrolled'},
          {
            ...clusterLayerHousehold,
            paint: {
              ...clusterLayerHousehold.paint,
              ...circlePurple
            },
            id: 'clustered-partialEnrolled'
          },
          {
            ...clusterCountLayerHousehold,
            paint: textWhite,
            id: 'clusterCount-partialEnrolled'
          }
        ]
      }
    ]
  } else {
    return [
      {
        key: 'fullEnrolled',
        data: {...data, features: fullEnrolled},
        style: heatMapStyles[1],
        opacity: 0.9
      },
      {
        key: 'notEnrolledAndPartialEnrolled',
        data: {...data, features: [...notEnrolled, ...partialEnrolled]},
        style: heatMapStyles[0],
        opacity: 0.8
      }
    ]
  }
}

export const getMapAccessKey = () => {
  return process.env.NODE_ENV === 'production'
    ? globalThis.__env.REACT_APP_MAP_TILER_API_KEY
    : process.env.REACT_APP_MAP_TILER_API_KEY
}

const getHeatMapStyleForPersona = (personaKey) => {
  return [
    'interpolate',
    ['linear'],
    ['heatmap-density'],
    0,
    theme.palette.heatmapColor.default,
    0.3,
    theme.palette.personaColor[personaKey][2],
    0.6,
    theme.palette.personaColor[personaKey][1],
    1,
    theme.palette.personaColor[personaKey][0]
  ]
}
export const getGroupedDataByPersona = (data, personasList, personasConfig) => {
  const filteredData = personasList.map((persona) => {
    const personaKey = personasConfig?.personas?.[persona.trim()]
    return {
      data: {...data, features: data.features.filter((feature) => feature.properties.persona?.trim() === persona)},
      key: personaKey,
      style: getHeatMapStyleForPersona(personaKey),
      layers: [
        {
          ...unclusteredLayerHousehold,
          paint: {
            ...unclusteredLayerHousehold.paint,
            'circle-color': theme.palette.personaColor[personaKey][0]
          },
          id: `unclustered-${personaKey}`,
          source: unclusteredLayerHousehold.source + personaKey
        },
        {
          ...clusterLayerHousehold,
          paint: {
            ...clusterLayerHousehold.paint,
            'circle-color': theme.palette.personaColor[personaKey][0]
          },
          id: `clustered-${personaKey}`,
          source: unclusteredLayerHousehold.source + personaKey
        },
        {
          ...clusterCountLayerHousehold,
          id: `clusterCount-${personaKey}`,
          source: unclusteredLayerHousehold.source + personaKey,
          paint: {'text-color': theme.palette.hpBaseDarker}
        }
      ]
    }
  })
  filteredData?.sort((a, b) => b.data.features.length - a.data.features.length)
  return filteredData
}

export const getPersonaColor = (personasConfig, persona) => {
  const personaKey = personasConfig?.personas?.[persona]
  if (personaKey && theme.palette.personaColor[personaKey]) {
    return theme.palette.personaColor[personaKey][0]
  }
  return '#CCCCCC'
}

export const renderClusterLayer = (type) => {
  switch (type) {
    case 'hospitals':
      return (
        <Layer
          {...clusterLayerHospitals}
          paint={{...clusterLayerHospitals.paint, 'circle-color': theme.palette.hpRedDark}}
        />
      )
    case 'urgentCare':
      return (
        <Layer
          {...clusterLayerUrgentCare}
          paint={{...clusterLayerUrgentCare.paint, 'circle-color': theme.palette.hpOrangeDark}}
        />
      )
    case 'groceryStores':
      return (
        <Layer
          {...clusterLayerGrocery}
          paint={{...clusterLayerGrocery.paint, 'circle-color': theme.palette.hpYellowDarker}}
        />
      )
    case 'pharmacies':
      return (
        <Layer
          {...clusterLayerPharmacy}
          paint={{...clusterLayerPharmacy.paint, 'circle-color': theme.palette.hpBaseDarker}}
        />
      )
    case 'childCare':
      return (
        <Layer
          {...clusterLayerChildcare}
          paint={{...clusterLayerPharmacy.paint, 'circle-color': theme.palette.hpYellowDark}}
        />
      )
    case 'obgynPhysicianFacilities':
      return (
        <Layer
          {...clusterLayerObgyn}
          paint={{...clusterLayerObgyn.paint, 'circle-color': theme.palette.hpGreenVividDark}}
        />
      )
    case 'mentalHealthCareFacilities':
      return (
        <Layer
          {...clusterLayerMentalHealthCareFacilities}
          paint={{...clusterLayerMentalHealthCareFacilities.paint, 'circle-color': theme.palette.hpPupleDark}}
        />
      )
    case 'fqhc':
      return (
        <Layer
          {...clusterLayerFqhc}
          paint={{...clusterLayerFqhc.paint, 'circle-color': theme.palette.hpBrownLighter}}
        />
      )
    default:
      return null
  }
}

export const renderClusterCountLayer = (type) => {
  switch (type) {
    case 'hospitals':
      return <Layer {...clusterCountLayerHospitals} />
    case 'urgentCare':
      return <Layer {...clusterCountLayerUrgentCare} />
    case 'groceryStores':
      return <Layer {...clusterCountLayerGrocery} />
    case 'pharmacies':
      return <Layer {...clusterCountLayerPharmacies} />
    case 'childCare':
      return <Layer {...clusterCountLayerChildcare} />
    case 'obgynPhysicianFacilities':
      return <Layer {...clusterCountLayerObgyn} />
    case 'mentalHealthCareFacilities':
      return <Layer {...clusterCountLayerMentalHealthCareFacilities} />
    case 'fqhc':
      return <Layer {...clusterCountLayerFqhc} />
    default:
      return null
  }
}

export const allStatesFips = () => {
  return statesToFIPS.map((state) => state.code)
}

export const handleStateHover = (
  event,
  map,
  stateFipsToProperties,
  personasToggle,
  setTileLayerHoverInfo,
  {stateTilesetSourceLayer, stateDict, populationAggregationData, setHoverInfo}
) => {
  // Get the State Layer
  const stateFeatures = event?.target?.queryRenderedFeatures(event.point, {
    layers: map?.getLayer('state-fill') && ['state-fill']
  })

  /* Remove enabled feature state to remove highlight from the
       previously selected state */
  map?.removeFeatureState({
    source: 'states',
    sourceLayer: stateTilesetSourceLayer
  })

  // If state layer is hovered, highlight the selected state
  if (stateFeatures[0] && map?.getLayer('state-fill')) {
    map?.setFeatureState(
      {
        source: 'states',
        sourceLayer: stateTilesetSourceLayer,
        id: stateFeatures[0].id
      },
      {
        hover: true
      }
    )

    const statewiseData = populationAggregationData.map((state) => [state.fips, state.count])
    const missingStates = allStatesFips().filter((fips) => !statewiseData.some((item) => item[0] === fips))

    // Set proper information on Tilelayer Tooltip
    setHoverInfo()
    let info = null
    if (missingStates?.includes(stateFeatures[0]?.id)) {
      info = {
        id: stateFeatures[0]?.layer?.id,
        data: getMissingStateData(stateFeatures),
        personaData: personasToggle ? stateFipsToProperties[stateFeatures[0]?.id] : false,
        lng: event.lngLat.lng,
        lat: event.lngLat.lat,
        x: event?.point?.x,
        y: event?.point?.y
      }
    } else {
      info = {
        id: stateFeatures[0]?.layer?.id,
        data: stateDict[stateFeatures[0]?.id],
        personaData: personasToggle ? stateFipsToProperties[stateFeatures[0]?.id] : false,
        lng: event.lngLat.lng,
        lat: event.lngLat.lat,
        x: event?.point?.x,
        y: event?.point?.y
      }
    }
    stateDict && setTileLayerHoverInfo(info)
  }
}

/* 
  This Function will highlight the hovered census tract and set Proper Information 
  on the TileLayer Tooltip 
  */
export const handleCensusTractHover = (
  event,
  map,
  censusTractDict,
  personasToggle,
  censusTractFipsToProperties,
  setTileLayerHoverInfo,
  {censusTractTilesetSourceLayer, censusTractData}
) => {
  // Define all census tract layer/source pairs
  const censusTractLayers = [
    {fillLayer: 'censustract-fill', source: 'censustract'},
    {fillLayer: 'censustract-fill1', source: 'censustract1'},
    {fillLayer: 'censustract-fill2', source: 'censustract2'},
    {fillLayer: 'censustract-fill3', source: 'censustract3'},
    {fillLayer: 'censustract-fill4', source: 'censustract4'},
    {fillLayer: 'censustract-filln', source: 'censustractn'}
  ]

  // Remove hover state from ALL census tract sources
  for (const {source} of censusTractLayers) {
    if (map?.getSource(source)) {
      map?.removeFeatureState({
        source,
        sourceLayer: censusTractTilesetSourceLayer
      })
    }
  }

  // Query ALL census tract fill layers that exist on the map
  const availableLayers = censusTractLayers
    .filter(({fillLayer}) => map?.getLayer(fillLayer))
    .map(({fillLayer}) => fillLayer)

  if (availableLayers.length === 0) return

  const censusTractFeatures = event.target.queryRenderedFeatures(event.point, {
    layers: availableLayers
  })

  if (censusTractFeatures[0]) {
    // Find the matching source for the hit layer
    const hitLayerId = censusTractFeatures[0]?.layer?.id
    const matchedEntry = censusTractLayers.find(({fillLayer}) => fillLayer === hitLayerId)
    const hitSource = matchedEntry?.source || 'censustract'

    map?.setFeatureState(
      {
        source: hitSource,
        sourceLayer: censusTractTilesetSourceLayer,
        id: censusTractFeatures[0].id
      },
      {
        hover: true
      }
    )

    const censusTractData1 = censusTractDict[censusTractFeatures[0]?.id]
    const censusTractProperties = censusTractFeatures[0]?.properties
    // const missingData = getMissingCensusTractData(censusTractFeatures)

    let info = null

    if (censusTractData?.censusTract?.missingGeoIds?.includes(censusTractFeatures[0]?.id)) {
      info = getAllInfoCensusTractData(censusTractFeatures, event, personasToggle, censusTractFipsToProperties)
    } else {
      info = {
        id: censusTractFeatures[0]?.layer?.id,
        data: censusTractData1
          ? {
              ...censusTractData1,
              censusTractId: censusTractFeatures[0]?.id,
              tractCode: censusTractProperties?.TRACTCE
            }
          : censusTractData1,
        personaData: personasToggle ? censusTractFipsToProperties[censusTractFeatures[0]?.id] : false,
        lng: event.lngLat.lng,
        lat: event.lngLat.lat,
        x: event?.point?.x,
        y: event?.point?.y
      }
    }
    censusTractDict && setTileLayerHoverInfo(info)
  }
}

export const handleCongressionalDistrictHover = (
  event,
  map,
  congressionalDistrictDict,
  personasToggle,
  congressionalDistrictFipsToProperties,
  setTileLayerHoverInfo,
  {congressionalDistrictTilesetSourceLayer, congressionalDistrictData}
) => {
  // Get the congressional district Layer
  const congressionalDistrictFeatures = event.target.queryRenderedFeatures(event.point, {
    layers: map?.getLayer('congressionaldistrict-fill') && ['congressionaldistrict-fill']
  })

  map?.removeFeatureState({
    source: 'congressionaldistrict',
    sourceLayer: congressionalDistrictTilesetSourceLayer
  })

  if (congressionalDistrictFeatures[0] && map?.getLayer('congressionaldistrict-fill')) {
    map?.setFeatureState(
      {
        source: 'congressionaldistrict',
        sourceLayer: congressionalDistrictTilesetSourceLayer,
        id: congressionalDistrictFeatures[0].id
      },
      {
        hover: true
      }
    )

    let info = null
    // populationDensityData.missingGeoIds.includes(countyFeatures[0]?.id)
    const missingData = getMissingCongressionalDistrictData(congressionalDistrictFeatures)
    if (
      congressionalDistrictData?.congressionalDistrict?.missingGeoIds?.includes(congressionalDistrictFeatures[0]?.id)
    ) {
      info = {
        id: congressionalDistrictFeatures[0]?.layer?.id,
        data: missingData,
        personaData: personasToggle
          ? congressionalDistrictFipsToProperties[congressionalDistrictFeatures[0]?.id]
          : false,
        lng: event.lngLat.lng,
        lat: event.lngLat.lat,
        x: event?.point?.x,
        y: event?.point?.y
      }
    } else {
      info = {
        id: congressionalDistrictFeatures[0]?.layer?.id,
        data: congressionalDistrictDict[congressionalDistrictFeatures[0]?.id],
        personaData: personasToggle
          ? congressionalDistrictFipsToProperties[congressionalDistrictFeatures[0]?.id]
          : false,
        lng: event.lngLat.lng,
        lat: event.lngLat.lat,
        x: event?.point?.x,
        y: event?.point?.y
      }
    }
    congressionalDistrictDict && setTileLayerHoverInfo(info)
  }
}

export const getTableDataToExport = ({
  selectedGeoBoundary,
  personasToggle,
  enrichedCongressionalDistricts,
  sortedCongressionalDistricts,
  populationDensityData,
  censusTractData,
  getDominantPersonaData,
  populationAggregationData
}) => {
  let data = []
  if (selectedGeoBoundary === 'congressionaldistrict') {
    data = personasToggle ? enrichedCongressionalDistricts || [] : sortedCongressionalDistricts || []
  } else if (selectedGeoBoundary === 'county') {
    data = populationDensityData?.populationDensity || []
    if (personasToggle) {
      data = getDominantPersonaData(data, selectedGeoBoundary)
    }
  } else if (selectedGeoBoundary === 'censustract') {
    data = censusTractData?.censusTract?.censusTract || []
    if (personasToggle) {
      data = getDominantPersonaData(data, selectedGeoBoundary)
    }
  } else {
    data = populationAggregationData || []
    if (personasToggle) {
      data = getDominantPersonaData(data, selectedGeoBoundary)
    }
  }
  return Array.isArray(data) ? data : []
}

/**
 * Get table columns using filter management system
 * @param {boolean} isOutreachActive - From useOutreachFilters().isOutreachActive
 * @param {string} selectedGeoBoundary - Current geographic boundary
 * @param {boolean} personasToggle - Whether personas are enabled
 * @param {Object} tableData - Table configuration data
 * @param {Function} getOutreachCols - Function to get outreach columns
 * @param {Object} options - Additional options { isFilterApplied, dataKeyIdentifier }
 * @returns {Array} Array of column configurations
 */
export const getTableColumns = (
  isOutreachActive,
  selectedGeoBoundary,
  personasToggle,
  tableData,
  getOutreachCols,
  options = {}
) => {
  const {isFilterApplied = false, dataKeyIdentifier = 'key'} = options
  let tableCols
  if (isOutreachActive) {
    tableCols = getOutreachCols()
  } else if (selectedGeoBoundary === 'congressionaldistrict') {
    tableCols = tableData.congressionalDistrictColumns
  } else {
    tableCols = tableData.defaultColumns
  }

  const columns = Object.keys(tableCols).map((label) => ({
    label,
    [dataKeyIdentifier]: tableCols[label],
    type: label.includes('%') ? 'percentage' : null
  }))

  addColumnsBasedOnBoundary(columns, selectedGeoBoundary, isFilterApplied, isOutreachActive, dataKeyIdentifier)

  if (personasToggle) {
    const personaColumn = {label: 'Leading Persona', [dataKeyIdentifier]: 'dominant_persona', type: null}

    if (selectedGeoBoundary === 'state') {
      columns.splice(1, 0, personaColumn)
    } else if (selectedGeoBoundary === 'county' || selectedGeoBoundary === 'congressionaldistrict') {
      columns.splice(2, 0, personaColumn)
    } else if (selectedGeoBoundary === 'censustract') {
      columns.splice(4, 0, personaColumn)
    }
  }

  return columns
}

export const hasValidStateData = (stateContext) => {
  return stateContext && stateContext?.length > 0 && !stateContext?.includes('No Data')
}

export const shouldSkipQuery = (isLoading, stateContext) => {
  return isLoading || !hasValidStateData(stateContext)
}
export const addColumnsBasedOnBoundary = (
  dynamicColumn,
  selectedGeoBoundary,
  isFilterSelected,
  isOutreachSimulationSelected,
  dataKeyIdentifier = 'key'
) => {
  const boundaryConfigs = {
    county: {
      additionalColumns: [
        {label: 'County', dataKey: 'county', index: 1},
        {label: 'Total County Population', dataKey: 'countyPopulation', index: 2}
      ],
      conditionalColumns: {
        filtered: [
          {label: 'Selected Population', dataKey: 'population', index: 3},
          {label: 'Selected Population (% of County)', dataKey: 'countyPercentage', index: 4}
        ],
        default: [{label: 'Population (% of State)', dataKey: 'statePercentage', index: 3}]
      }
    },
    congressionaldistrict: {
      additionalColumns: [
        {label: 'Total Cong. District Population', dataKey: 'congressionalDistrictPopulation', index: 2}
      ],
      conditionalColumns: {
        filtered: [
          {label: 'Selected Population', dataKey: 'population', index: 3},
          {
            label: 'Selected Population (% of Cong. District)',
            dataKey: 'congressionalDistrictPercentage',
            index: 4
          }
        ],
        default: [{label: 'Population (% of State)', dataKey: 'statePercentage', index: 3}]
      }
    },
    censustract: {
      additionalColumns: [
        {label: 'County', dataKey: 'county', index: 1},
        {label: 'Census Tract', dataKey: 'censusTractGeoId', index: 2},
        {label: 'Total Census Tract Population', dataKey: 'censusTractPopulation', index: 3}
      ],
      conditionalColumns: {
        filtered: [
          {label: 'Selected Population', dataKey: 'population', index: 4},
          {label: 'Selected Population (% of Census Tract)', dataKey: 'censusTractPercentage', index: 5}
        ],
        default: [{label: 'Population (% of County)', dataKey: 'countyPercentage', index: 4}]
      }
    },
    state: {
      additionalColumns: [{label: 'Total State Population', dataKey: 'statePopulation', index: 1}],
      conditionalColumns: {
        filtered: [
          {label: 'Selected Population', dataKey: 'population', index: 2},
          {label: 'Selected Population (% of State)', dataKey: 'statePercentage', index: 3}
        ],
        default: [{label: 'Population (% of US)', dataKey: 'usPercentage', index: 2}]
      }
    }
  }

  const config = boundaryConfigs[selectedGeoBoundary]
  if (!config) return

  // Add additional columns
  for (const col of config.additionalColumns) {
    dynamicColumn.splice(col.index, 0, {
      label: col.label,
      [dataKeyIdentifier]: col.dataKey,
      type: col.label.includes('%') ? 'percentage' : null
    })
  }

  // Add conditional columns based on filter selection
  let conditionalCols = []
  if (!isOutreachSimulationSelected) {
    conditionalCols = isFilterSelected ? config.conditionalColumns.filtered : config.conditionalColumns.default
  }

  for (const col of conditionalCols) {
    dynamicColumn.splice(col.index, 0, {
      label: col.label,
      [dataKeyIdentifier]: col.dataKey,
      type: col.label.includes('%') ? 'percentage' : null
    })
  }
}

// returns true if any filter is applied in the sidebar (sdoh, states and health conditions or outreach simulation)

/**
 * Check if any filter is applied using filter management system
 * @param {Array} filters - Filters array from breadcrumbs (for Individual Health from old system)
 * @param {boolean} isOutreachActive - From useOutreachFilters().isOutreachActive
 * @returns {boolean} True if any filter is applied
 */

export const checkIsFilterApplied = (appliedFilters) => {
  return Object.keys(appliedFilters).length > 0
}

export const updateOutreachPercentageColumnLabels = (currentCol, selectedGeoBoundary, benefitType) => {
  if (!currentCol || !selectedGeoBoundary) {
    return currentCol
  }

  // Map geography boundary values to proper display names
  const geographyNameMap = {
    state: 'State',
    county: 'County',
    congressionaldistrict: 'Cong. District',
    censustract: 'Census Tract'
  }

  const percentageKeyMap = {
    state: {SNAP: ['stateSnapEnrolledPercentage', 'stateSnapNotEnrolledPercentage']},
    county: {SNAP: ['countySnapEnrolledPercentage', 'countySnapNotEnrolledPercentage']},
    congressionaldistrict: {SNAP: ['congressionalSnapEnrolledPercentage', 'congressionalSnapNotEnrolledPercentage']},
    censustract: {SNAP: ['censusTractSnapEnrolledPercentage', 'censusTractSnapNotEnrolledPercentage']}
  }

  const geographyDisplayName = geographyNameMap[selectedGeoBoundary] || 'Geography'

  // Create a new object with base columns and added percentage columns
  const updatedCol = {}

  for (const [index, label] of Object.keys(currentCol).entries()) {
    const dataKey = currentCol[label]

    // Add the base column
    updatedCol[label] = dataKey

    // Add percentage column for each base column
    const percentageLabel = `${label} (% of ${geographyDisplayName})`
    const percentageDataKey = percentageKeyMap[selectedGeoBoundary][benefitType][index]
    updatedCol[percentageLabel] = percentageDataKey
  }

  return updatedCol
}

export const getUpdatedData = (rawData, personasConfig) => {
  // Check if rawData is valid and has items
  if (!rawData || !Array.isArray(rawData) || rawData.length === 0) {
    return rawData
  }

  // Check if the first item has dominant_persona property
  if (rawData[0]?.dominant_persona) {
    return rawData.map((data) => ({
      ...data,
      dominant_persona: getPersonaCustomName(data.dominant_persona, personasConfig)
    }))
  }

  return rawData
}

export const getPersonaPaintProperty = (stateFipsToPersona, personasConfig) => {
  return {
    'fill-opacity': 0.8,
    'fill-color': [
      'match',
      ['get', 'GEOID'],
      ...Object.entries(stateFipsToPersona).flatMap(([fips]) => [
        fips,
        getPersonaColor(personasConfig, stateFipsToPersona[fips])
      ]),
      theme?.palette?.hpYellowLightest || '#FFFAE7'
    ]
  }
}

export const getDefaultPaintProperty = (statewiseAggregation, colors) => {
  return {
    'fill-opacity': 0.8,
    'fill-color': [
      'case',
      // Condition: population < 1
      ['<', ['match', ['get', 'GEOID'], ...statewiseAggregation.flat(), -1], 0.9],
      theme?.palette?.hpYellowLight || '#FFF9DE', // If true: apply low population color
      // Else: use normal interpolation
      ['interpolate', ['linear'], ['match', ['get', 'GEOID'], ...statewiseAggregation.flat(), -1], ...colors.flat()]
    ]
  }
}

/**
 * Determines the paint properties for the map layer based on personas or population density data.
 *
 * @param {String} paintType - Type of paint property to apply ('personas' or 'populationDensity').
 * @param {Object} stateFipsToPersona - Mapping of state FIPS codes to personas.
 * @param {Object} personasConfig - Configuration for personas.
 * @param {Array} statewiseAggregation - Population data for states.
 * @param {Array} colors - Color scale for population density.
 * @return {Object} Paint properties for the map layer.
 *
 */
export const getPaintProperty = (layerType, stateFipsToPersona, personasConfig, statewiseAggregation, colors) => {
  switch (layerType) {
    case 'personas':
      return getPersonaPaintProperty(stateFipsToPersona, personasConfig)
    case 'populationDensity':
    case 'congressionalDistrict':
    case 'censusTract':
      return getDefaultPaintProperty(statewiseAggregation, colors)
    default:
      return null
  }
}

/**
 *
 * This function formats the percentage value to a number.
 * @param {String} percentage - The percentage value to format.
 * @returns {Number} The formatted percentage value.
 */
export const formatPercentage = (percentage) => {
  if (percentage == null) return 0
  if (typeof percentage === 'number') return percentage
  if (percentage.includes('<')) {
    return Number(percentage.substring(1)) - 0.1
  } else if (percentage.includes('>')) {
    return Number(percentage.substring(1)) + 0.1
  } else {
    return Number(percentage)
  }
}

export const generateColorStops = (aggregation, mapColors, isPercentage = false, from = 'state') => {
  const nonZeroData = aggregation.filter((d) => d[1] > 0)
  if (nonZeroData.length === 0) return [[0, mapColors[0]]]
  const minPopulation = d3.min(nonZeroData, (d) => d[1])
  const maxPopulation = d3.max(nonZeroData, (d) => d[1])
  if (minPopulation === maxPopulation) {
    return [[minPopulation, d3.scaleQuantile().domain([minPopulation]).range(mapColors)(minPopulation)]]
  }

  const numColorStops = mapColors.length

  let colorStops
  if (isPercentage) {
    colorStops = Array.from({length: numColorStops}, (_, i) => {
      const populationValue = Math.exp(
        Math.log(minPopulation) + i * ((Math.log(maxPopulation) - Math.log(minPopulation)) / (numColorStops - 1))
      )
      return [populationValue, mapColors[i]]
    })
  } else {
    const colorScale = d3
      .scaleQuantile()
      .domain(nonZeroData.map((d) => d[1]))
      .range(mapColors)

    colorStops = Array.from({length: numColorStops}, (_, i) => {
      const populationValue = Math.exp(
        Math.log(minPopulation) + i * ((Math.log(maxPopulation) - Math.log(minPopulation)) / (numColorStops - 1))
      )
      return [populationValue, colorScale(populationValue)]
    })
  }
  return colorStops
}

export const getMapColors = (theme) => {
  return [
    theme.palette.hpAccentLightYellow,
    theme.palette.hpAccentYellowGreen,
    theme.palette.hpAccentAqua,
    theme.palette.hpAccentAquaGreen,
    theme.palette.hpAccentPersianGreen,
    theme.palette.hpPrimaryDark,
    theme.palette.hpPrimaryDarkest
  ]
}

export const getMissingStateData = (stateFeatures) => {
  return {
    state: stateFeatures[0]?.properties?.NAME,
    population: 0,
    count: 0,
    statePopulation: 0,
    statePercentage: 0,
    usPercentage: 0,
    ...getOutreachSimulationTooltipFieldData()
  }
}

export const getMissingCountyData = (countyFeatures) => {
  return {
    state: statesToFIPS.find((state) => state.code === countyFeatures[0]?.properties?.STATEFP)?.name,
    county: countyFeatures[0]?.properties?.NAMELSAD,
    population: 0,
    count: 0,
    countyPopulation: 0,
    countyPercentage: 0,
    statePercentage: 0,
    ...getOutreachSimulationTooltipFieldData()
  }
}

const getOrdinalSuffix = (num) => {
  const n = Number.parseInt(num)
  if (Number.isNaN(n)) return num // return as-is if not a number (e.g. "At Large")

  const suffixes = ['th', 'st', 'nd', 'rd']
  // Special case for 11, 12, 13 (they use 'th' not 'st', 'nd', 'rd')
  const mod100 = n % 100
  const mod10 = n % 10

  if (mod100 >= 11 && mod100 <= 13) return `${n}th`

  return `${n}${suffixes[mod10] || 'th'}`
}

export const getMissingCongressionalDistrictData = (congressionalDistrictFeatures) => {
  let cdName = congressionalDistrictFeatures[0]?.properties?.NAMELSAD?.replace(/^[A-Z]{2}\s+/, '').trim()

  if (cdName === '(at Large)') cdName = 'At Large'
  else cdName = getOrdinalSuffix(cdName)

  return {
    state: statesToFIPS.find((state) => state.code === congressionalDistrictFeatures[0]?.properties?.STATEFP)?.name,
    congressional_district: cdName || congressionalDistrictFeatures[0]?.properties?.NAMELSAD,
    population: 0,
    count: 0,
    congressionalDistrictPopulation: 0,
    congressionalDistrictPercentage: 0,
    statePercentage: 0,
    ...getOutreachSimulationTooltipFieldData()
  }
}

export const getMissingCensusTractData = (censusTractFeatures) => {
  const geoid = censusTractFeatures[0]?.properties?.GEOID || censusTractFeatures[0]?.id

  // Extract state FIPS (first 2 digits) and county FIPS (digits 3-5)
  const stateFips = geoid ? String(geoid).substring(0, 2) : null
  const countyFips = geoid ? String(geoid).substring(0, 5) : null

  const stateName = statesToFIPS.find((state) => state.code === stateFips)?.name

  // Use NAMELSADCO from properties if available, otherwise fall back to GEOID-derived county
  // countyFipsMap is a mapping of county FIPS codes to county names, which can be used as a fallback if NAMELSADCO is not present
  // Update the array of county FIPS codes in countyFipsMap to include the relevant counties for your dataset
  const countyName = censusTractFeatures[0]?.properties?.NAMELSADCO || countyFipsMap.get(countyFips) || countyFips

  return {
    state: stateName,
    censusTractId: censusTractFeatures[0]?.id,
    population: 0,
    count: 0,
    county: countyName,
    censusTractPopulation: 0,
    censusTractPercentage: 0,
    statePercentage: 0,
    countyPercentage: 0,
    ...getOutreachSimulationTooltipFieldData()
  }
}

export const getAllInfoCensusTractData = (censusTractFeatures, event, personasToggle, censusTractFipsToProperties) => {
  return {
    id: censusTractFeatures[0]?.layer?.id,
    data: getMissingCensusTractData(censusTractFeatures),
    personaData: personasToggle ? censusTractFipsToProperties[censusTractFeatures[0]?.id] : false,
    lng: event.lngLat.lng,
    lat: event.lngLat.lat,
    x: event?.point?.x,
    y: event?.point?.y
  }
}
export const getMissingPersonaCountyData = (countyFeatures) => {
  return {
    state: statesToFIPS.find((state) => state.code === countyFeatures[0]?.properties?.STATEFP)?.name,
    county: countyFeatures[0]?.properties?.NAMELSAD,
    dominant_persona: 'none',
    persona_cohort: 'none',
    persona_population: 0,
    countyPercentage: 0,
    statePercentage: 0
  }
}

export const getMissingPersonaData = (features) => {
  return {
    state: statesToFIPS.find((state) => state.code === features[0]?.properties?.STATEFP)?.name,
    county: features[0]?.properties?.NAMELSAD,
    dominant_persona: 'none',
    persona_cohort: 'none',
    persona_population: 0,
    countyPercentage: 0,
    statePercentage: 0
  }
}

export const getMissingPersonaCensusTractData = (censusTractFeatures) => {
  return {
    state: statesToFIPS.find((state) => state.code === censusTractFeatures[0]?.properties?.STATEFP)?.name,
    county: censusTractFeatures[0]?.properties?.NAMELSADCO,
    censusTractId: censusTractFeatures[0]?.id,
    dominant_persona: 'none',
    persona_cohort: 'none',
    persona_population: 0,
    censusTractPercentage: 0,
    countyPercentage: 0,
    statePercentage: 0
  }
}

/**
 * List of functions and their purpose:
 *
 * - conv4326To900913: Converts geographic coordinates from EPSG:4326 to EPSG:900913 format.
 * - debounce: Creates a debounced version of a function to delay its execution.
 * - loadImageToMap: Adds an image to the map instance if it doesn't already exist.
 * - loadImages: Loads multiple POI images into the map instance.
 * - loadOutreachSimulationImage: Loads an outreach simulation image into the map instance.
 * - getGroupedData: Groups data based on selected outreach simulation keys and focus layer.
 * - filterDataBySelectedKeys: Filters data by selected keys and applies styles for visualization.
 * - getMapAccessKey: Retrieves the MapTiler API key based on the environment.
 * - getHeatMapStyleForPersona: Generates heatmap styles for a specific persona.
 * - getGroupedDataByPersona: Groups data by personas and applies styles for visualization.
 * - getPersonaColor: Retrieves the color associated with a persona from the theme configuration.
 * - getPOIQuery: Constructs a GraphQL query for fetching points of interest (POI) data.
 * - addColumnsBasedOnBoundary: Dynamically adds columns to a data table based on the selected geographic boundary and filter status.
 * - checkIsFilterApplied: Checks if any filter is applied using filter management system.
 * - updateOutreachPercentageColumnLabels: Updates the percentage column labels to include the selected geography boundary.
 */
